import * as React from "react";
import { RouteCard } from "./RouteCard";

export function RouteExplainer({ sentences }: { sentences: string[] }) {
  return (
    <RouteCard title="What happens when a client clicks">
      <ol className="flex flex-col gap-2.5" data-testid="route-explainer">
        {sentences.map((sentence, index) => (
          <li key={index} className="flex gap-3 text-sm text-slate-700 leading-relaxed">
            <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-indigo-50 text-[11px] font-bold text-primary">
              {index + 1}
            </span>
            <span>{sentence}</span>
          </li>
        ))}
      </ol>
    </RouteCard>
  );
}
